import Vue from 'vue'

import 'normalize.css/normalize.css'

import ElementUI from 'element-ui'
import 'umy-ui/lib/theme-chalk/index.css' // 引入列表ux-grid优化样式
import 'element-ui/lib/theme-chalk/index.css'
import UmyUi from 'umy-ui' // 大数据表格优化插件

import '@/styles/index.less'

import JsEncrypt from 'jsencrypt'
import Base64 from 'js-base64'

import App from './App.vue'
import router from './router/index'
import store from './store/index'
import moment from 'moment' // 时间格式化工具

import Waves from '@/directive/waves'
import * as filters from './filters' // global filters

import './utils/rem' // 转rem
import SIdentify from './views/login/identify'
// echarts
import echarts from 'echarts'
// leaflet
// 引入样式文件
import 'leaflet/dist/leaflet.css'
import axios from 'axios'
// 引入Leaflet对象 挂载到Vue上，便于全局使用，也可以单独页面中单独引用
// 图标库引用
import './assets/styles/iconfont.css'
import './assets/styles/iconfont.js'
import '@/utils/globalFun'
// 引入全局变量组件
import global_ from './views/global'
import commonFunctions from './views/global/functions'

Vue.prototype.Global = global_
Vue.use(commonFunctions)

Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.prototype.$echarts = echarts
Vue.prototype.$jsEncrypt = JsEncrypt
Vue.prototype.$moment = moment
Vue.prototype.$base64 = Base64
Vue.use(SIdentify)

Vue.use(ElementUI)
Vue.use(UmyUi)
Vue.use(Waves)

// 注册全局过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
